import script from "./NetworkLogsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkLogsView.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkLogsView.vue?vue&type=style&index=0&id=03e8b930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e8b930"]])

export default __exports__